<template>
  <footer :class="classList">
    <slot>
      <div>
        <span>&copy; 2018 - 2023 EFORT</span>
      </div>
      <div class="ml-auto">
        EFORT - NORE, the Network of Orthopaedic Registries of Europe
      </div>
    </slot>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
    this.isFixed();
  },
  computed: {
    classList() {
      return ["app-footer"];
    }
  },
  methods: {
    isFixed() {
      this.fixed
        ? document.body.classList.add("footer-fixed")
        : document.body.classList.remove("footer-fixed");
    }
  }
};
</script>
